import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import getters from './getters'
import app from './modules/app'
import login from './modules/auth'
// import auth from "./modules/auth"
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    login,
    app,
  },
  getters,
  // plugins: [createPersistedState()]
})

export default store
